// extracted by mini-css-extract-plugin
module.exports = {"title":"_3XfZ27Mvmk7wGMl8q-i4AN","image":"_2XikDWxW1gpCeJ5Ie21C4w","heading":"PaDzpTEBwFXoXzoas__Ms","text":"_2RKga1Cs-Bm6Wm-ZNTYx-"};